import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TUser } from '../../types/userData';
import { SliceActions } from '../types';

const initialState: TUser = { canPublishOffer: false, isAuthenticated: false, publicProfile: false, userId: 0 };

const userSlice = createSlice({
  name: 'user',
  reducers: {
    setUserId: (state, action: PayloadAction<number>) => {
      state.userId = action.payload;
    },
    setUserUnauthenticated: state => {
      state.isAuthenticated = false;
    },
  },
  initialState,
});

export const userReducer = userSlice.reducer;
export const { setUserId, setUserUnauthenticated } = userSlice.actions;
export type TUserActions = SliceActions<typeof userSlice.actions>;
